<template>
    <b-form-group
        :valid-feedback="$attrs['valid-feedback']"
        :invalid-feedback="$attrs['invalid-feedback']"
        :state="$attrs.state"
    >
        <template #label>
            <label class="label" for="username">
                {{ $t('label') }}
            </label>
            <PopoverHelp v-if="showHelp" id="popover-username" :html="popoverHelp" />
        </template>
        <b-input-group>
            <b-form-input
                id="username"
                class="input"
                v-bind="$attrs"
                v-on="$listeners"
                type="text"
                :placeholder="$t('placeholder')"
            />
            <b-input-group-prepend is-text>
                <i class="fa fa-envelope" />
            </b-input-group-prepend>
        </b-input-group>
    </b-form-group>
</template>

<script>
import PopoverHelp from './PopoverHelp'

export default {
    name: 'InputUsername',
    components: { PopoverHelp },
    inheritAttrs: false,
    props: {
        showHelp: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    computed: {
        popoverHelp() {
            return [this.$t('popoverHelpEmail'), this.$t('popoverHelpCPF')]
        },
    },
    i18n: {
        messages: {
            'en-US': {
                label: 'Email',
                placeholder: 'Enter your email',
                popoverHelpEmail:
                    'Provide a valid email address.<br/>' +
                    "This should be your corporate email. If you have any questions, please contact your company's HR or send an email to <b>suporte@coblue.com.br</b>.<br/>" +
                    'Example: <i>user@domain.com</i>',
                popoverHelpCPF:
                    'You can also use a Brazilian CPF in place of the email if you have registered it in the app.<br/>' +
                    'Example: <i>12345678900</i> ou <i>123.456.789-00</i>',
            },
            'es-ES': {
                label: 'Correo electrónico',
                placeholder: 'Ingrese su correo electrónico',
                popoverHelpEmail:
                    'Proporcione una dirección de correo electrónico válida.<br/>' +
                    'Debe ser su correo electrónico corporativo. Si tiene alguna pregunta, comuníquese con el departamento de recursos humanos de su empresa o envíe un correo electrónico a <b>suporte@coblue.com.br</b>.<br/>' +
                    'Ejemplo: <i>usuario@dominio.com</i>',
                popoverHelpCPF:
                    'También puedes usar un CPF brasileño en lugar del correo electrónico si lo has registrado en el app.<br/>' +
                    'Ejemplo: <i>12345678900</i> ou <i>123.456.789-00</i>',
            },
            'pt-BR': {
                label: 'Email / CPF',
                placeholder: 'Insira seu email ou CPF',
                popoverHelpEmail:
                    'Informe um endereço de email válido.<br/>' +
                    'Este deve ser o seu email corporativo. Em caso de dúvidas fale com o RH da sua empresa ou envie um email para <b>suporte@coblue.com.br</b>.<br/>' +
                    'Exemplo: <i>usuario@dominio.com.br</i>',
                popoverHelpCPF:
                    'Caso você tenha cadastrado o seu CPF poderá utilizá-lo no lugar do email.<br/>' +
                    'Exemplo: <i>12345678900</i> ou <i>123.456.789-00</i>',
            },
        },
    },
}
</script>
